export const isPreviewMode = window._env_.REACT_APP_IS_PREVIEW_MODE && window._env_.REACT_APP_IS_PREVIEW_MODE === 'true';
